import { analytics, db, storage, auth, authProvider,
         adminDbPath, usersDbPath, imageDataDbPath } from "../firebaseConfig"
import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, where } from "firebase/firestore"
import { useLoaderData, useParams, useRouteLoaderData } from "react-router-dom"


const usersCollectionRef = collection(db, usersDbPath)

// profile of signed in user
export function SelfProfile() {
    
    
    
    
    return (
        <div id="self-profile">
            <h1>your own profile page</h1>
        </div>
    )
}
    

// profile of other user
export function OtherProfile() {
    let name = useLoaderData()
    
    
    
    return (
        <div id="other-profile">
            <h1>{name}'s profile page</h1>
        </div>
    )
}


// profile not found - bad profile
export function ProfileError() {
    let { name } = useParams()
    
    
    
    
    return (
        <div id="profile-error">
            <h1>profile {name} not found!</h1>
        </div>
    )
}


export async function getOfficialName(name) {
    //return (await getDocs(query(usersCollectionRef, where("name", "==", name)))).size > 0
    const input = name.trim().toLowerCase()
    const data = await getDocs(usersCollectionRef)
    for (let doc of data.docs) {
        const dbName = doc.get("name")
        if (input === dbName.trim().toLowerCase()) {
            return dbName
        }
    }
    return undefined
}